<template>
  <div class="register-modal">
    <client-only>
    <el-dialog
      :model-value="dialogVisible"
      :title="t('register.title')"
      width="820"
      :show-close="true"
      center
      :before-close="handleClose"
      :closeOnClickModal="false"
    >
      <div class="content">
        <div class="text1">{{ t('register.text1') }}</div>
        <div class="text2">{{ t('register.text2') }}</div>
        <el-form 
          :model="form" 
          label-width="100px" 
          style="width: 420px" 
          class="form" 
          ref="formRef"
          >
          <el-form-item :label="t('register.contactPerson')" prop='contactPerson' 
            :rules="[
              { required: true, message: t('register.contactPerson'), trigger: 'blur' },
            ]">
            <el-input v-model="form.contactPerson" clearable />
          </el-form-item>
          <el-form-item :label="t('register.contactPhone')" prop='contactPhone' 
            :rules="[
              { required: true, message: t('register.contactPhone'), trigger: 'blur' },
              { type: 'number', message: t('popup.number') },
            ]"  >
            <el-input v-model.number="form.contactPhone" clearable />
          </el-form-item>
          <el-form-item :label="t('register.companyName')" prop='companyName' 
            :rules="[
              { required: true, message: t('register.companyName'), trigger: 'blur' },
            ]">
            <el-input v-model="form.companyName" clearable />
          </el-form-item>
          <el-form-item :label="t('register.address')" prop='address' 
            :rules="[
             { required: true, message: t('register.address'), trigger: 'blur' },
            ]">
            <el-input v-model="form.address" clearable />
          </el-form-item>
          <el-form-item :label="t('register.companyEmail')" prop='companyEmail' 
            :rules="[
              { required: true, message: t('register.companyEmail'), trigger: 'blur' },
              { type: 'email', message: t('register.companyEmail'), trigger: ['blur', 'change'],}
            ]">
            <el-input v-model="form.companyEmail" clearable />
          </el-form-item>
          <el-form-item :label="t('register.companyCode')" prop='companyCode' >
            <el-input v-model="form.companyCode" clearable />
          </el-form-item>
          <el-form-item :label="t('register.intro')" prop='intro'>
            <el-input v-model="form.intro" clearable />
          </el-form-item>
        </el-form>
      </div>
      <template #footer>
        <div class="dialog-footer">
          <el-button type="primary" @click="onSubmit(formRef)" class="submit">{{ t('register.submit') }}</el-button>
        </div>
      </template>
    </el-dialog>
  </client-only>
  </div>
</template>

<script lang="ts" setup>
  import type { FormInstance  } from 'element-plus'
  import { ElMessage } from 'element-plus'
  import { useI18n } from 'vue-i18n'
  const { t } = useI18n();

  const dialogVisible= defineModel()

  const formRef = ref<FormInstance>()
  const form = reactive({
    contactPerson: '',
    contactPhone: '',
    companyName: '',
    companyCode: '',
    address: '',
    companyEmail: '',
    intro: ''
  })
  
  const onSubmit = async(formEl: FormInstance | undefined) => {
    if (!formEl) return
    await formEl.validate(async (valid, fields) => {
      if (valid) {
        try {
          const response = await registerSubmit(form);
          if(response.code == 200){
            dialogVisible.value = false
            resetForm(formRef.value)
            ElMessage({
              message: t('popup.success'),
              type: 'success',
            })
          }else{
            ElMessage({
              message: response.msg,
              type: 'warning',
            })
          }
        } catch (error) {
        }
      } else {
        console.log('error submit!', fields)
      }
    })
  }
  const resetForm = (formEl: FormInstance | undefined) => {
    if (!formEl) return
    formEl.resetFields()
  }
  const handleClose = ()=>{
    dialogVisible.value = false
    resetForm(formRef.value)
  }
</script>

<style lang="scss" >
.register-modal{
  white-space: normal;
  .el-dialog{
    padding: 0;
    overflow: hidden;
    border-radius: 30px;
    box-shadow: 0 0 18px rgba(0,0,0,0.61);
    padding-bottom: 40px;
  }
  header{
    height: 80px;
    line-height: 80px;
    background: #01a2e0;
    padding: 0;
    span{
      color: #fff;
      font-size: 21px;
    }
    .el-dialog__headerbtn{
      .el-dialog__close{
        color: #fff;
      }
      &:hover .el-dialog__close{
        color: #fff;
        opacity: 0.5;
      }
    }
    
  }
  .content{
    text-align: center;
    padding: 30px 10px 0;
    .text1{
      font-size: 16px;
      line-height: 19px;
    }
    .text2{
      font-size: 14px;
      line-height: 16px;
      margin: 18px 0 35px;
    }
  }
  .form{
    margin-left: 155px;
    .el-form-item__label{
      padding-right: 30px;
      font-size: 13px;
      white-space: nowrap;
    }
    .el-form-item{
      margin-bottom: 20px;
    }
  }
  .submit{
    width: 120px;
    height: 44px;
    border-radius: 11px;
    background-color: #01a2e0;
    font-size: 12px;
  }
}
</style>